import { Form } from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'

import useCreateBrandGroupProviderModal from '../../hooks/useCreateBrandGroupProviderModal'

type SelectBrandGroupProps = {
  createBrandGroupProviderModal: ReturnType<typeof useCreateBrandGroupProviderModal>,
  isTopModal: boolean,
}

const SelectBrandGroup = (props: SelectBrandGroupProps) => {
  const { createBrandGroupProviderModal, isTopModal } = props

  const {
    callbacks: {
      addBrandProvider,
      handleBrandSelector,
    },
    brandId,
    formPayload,
    unassignedBrandGroups,
  } = createBrandGroupProviderModal

  const {
    entityState: {
      brand_group_id,
      provider_id,
    },
    errors,
    handlers,
  } = formPayload

  return (
    <>
      <EntitySelector
        boxProps={{ marginBottom: 'large' }}
        callbacks={{
          // @ts-expect-error TS2345
          selectItem: brand => handleBrandSelector(brand),
        }}
        entityKey="brands"
        errorMessage={errors.brand_id}
        label="* Brand"
        marginTop="large"
        requestOptions={{
          assigned_provider_id: provider_id,
          include_brand_brand_groups: true,
        }}
        searchForwardProps={{
          listAction: (
            // @ts-expect-error TS2741
            <EntitySelector.CreateEntity
              onClick={() => addBrandProvider()}
              strings={{ create: 'Assign Provider to enable' }}
            />
          ),
        }}
        // @ts-expect-error TS2322
        selectedItemId={brandId}
        shouldRefetch={isTopModal}
      />

      {brandId && (
        <Form.Field
          errorMessage={errors.brand_group_id}
          label="* Brand Group"
        >
          {/*
           // @ts-expect-error TS2322 */}
          <select
            name="brand_group_id"
            value={brand_group_id}
            {...handlers}
          >
            <option value="">Please Select...</option>
            {unassignedBrandGroups.map(brandGroup => (
              <option key={brandGroup.id} value={brandGroup.id}>
                {brandGroup.title}
              </option>
            ))}
          </select>
        </Form.Field>
      )}
    </>
  )
}

export default SelectBrandGroup
